<template>
    <div class="pb-2">
        <div class="d-flex flex-row justify-content-center">
            <welcome-parchment></welcome-parchment>
        </div>
        <div class="d-flex flex-row justify-content-center background-parchment-connect">
            <div class="first-connect-wallet-mobile">
                <div class="d-flex flex-row justify-content-center eggs-game-logo">
                    <img width="220px" src="../assets/images/eggs-game.png" alt="">
                </div>
                <div class="d-flex flex-row justify-content-center mt-4">
                    <img width="220px" src="../assets/images/hue-saturation-3.webp" alt="">
                </div>
                <div class="d-flex flex-row justify-content-center mb-5" style="margin-top: -1px">
                    <button class="connect-wallet-button" @click="walletConnect">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img width="200px" src="../assets/images/connect-wallet-button.webp" alt="">
                            <span class="connect-wallet">{{ buttonText }}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WelcomeParchment from './WelcomeParchment.vue'
export default {
  components: { WelcomeParchment },
    name:'connect-wallet-mobile',
    props: {
        buttonText: {
            default: "Connect Wallet",
            type: String
        }
    },
    data(){
        return{
            
        }
    },
    methods:{
        walletConnect(){
            this.$emit('connectWallet' , true)
        }
    }
}
</script>
<style scoped>
.background-parchment-connect{
    background-image: url('../assets/images/first-component-web.webp');
    background-repeat: no-repeat;
    background-size: 298px 410px;
        width: 298px;
        height: 410px;
    margin:30px auto
}
.connect-wallet{
    color: #907242;
    position: absolute;
    font-size: 20px;
    top: 3px
}
.connect-wallet-button{
    border: none;
    background: none
}
.nft-image-text{
    margin: 5px 0 0 44px;
}
.eggs-game-logo{
    margin-top: 20px;
}
</style>